import {ShareKeyType} from "./paymentApi";

export type TipCurrency = "CZK" | "PLN";

export function toTipCurrency(tipCurrency?: string): TipCurrency {
    return tipCurrency === "PLN" ? "PLN" : "CZK";
}

export const tipAmounts: {[currency in TipCurrency]: {[key in ShareKeyType]: number[]}} = {
    CZK: {
        DELIVERY_STOP: [10, 20, 50],
        DELIVERY_ORDERER: [10, 20, 50],
    },
    PLN: {
        DELIVERY_STOP: [2, 5, 10],
        DELIVERY_ORDERER: [2, 5, 10],
    },
};

export const maxTipAmount: {[currency in TipCurrency]: number} = {
    CZK: 500,
    PLN: 100,
};

export const carColors = [
    "black",
    "blue",
    "brown",
    "green",
    "orange",
    "purple",
    "red",
    "silver",
    "white",
    "yellow",
];
